import * as DialogPrimitive from '@radix-ui/react-dialog'
import * as React from 'react'

export function Trigger({ children }: React.PropsWithChildren) {
  return <DialogPrimitive.Trigger asChild>{children}</DialogPrimitive.Trigger>
}
